import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction
  ? "https://schools.luth.gov.ng"
  : "http://localhost:3003";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (!res.ok) {
        setMessage(data.msg || "Something went wrong.");
      } else {
        setMessage(data.msg);
        // Optionally navigate to a confirmation page
        // navigate('/forgot-password-confirmation');
      }
    } catch (err) {
      console.error("Error sending reset link:", err);
      setMessage("Failed to send reset link. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />

      <form
        onSubmit={handleSubmit}
        style={{ maxWidth: "400px", margin: "0 auto", marginTop: "8rem" }}
      >
        <h2>Forgot Password</h2>
        <p>
          Enter your email address and we'll send you a link to reset your
          password. Check your spam folder if you don't see it in your inbox.
          Click on Looks Safe to view password reset Link.
        </p>
        <input
          type="email"
          required
          placeholder="Your email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ width: "100%", padding: "0.5rem", marginBottom: "1rem" }}
        />
        <button
          type="submit"
          disabled={loading}
          style={{ width: "100%", padding: "0.75rem", backgroundColor: "green" }}
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
        {message && <p style={{ marginTop: "1rem" }}>{message}</p>}
      </form>
    </>
  );
}
